var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny-ps",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12",
    width: 12,
    height: 12,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-edit-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\ttspan { white-space:pre }\n\t\t.shp0 { fill: #ffffff } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    className: "shp0",
    d: "M0.95 8.69L3.4 11.14L0.95 11.8C0.55 11.91 0.19 11.55 0.29 11.15L0.95 8.69ZM10.34 0.44L11.53 1.63C11.88 1.97 11.88 2.53 11.53 2.87L4.28 10.13L1.84 7.69L9.09 0.44C9.44 0.09 9.99 0.09 10.34 0.44Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Settings"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPencil);
export default __webpack_public_path__ + "static/media/icon-pencil.5600602846ecec9e5396d6840f119834.svg";
export { ForwardRef as ReactComponent };